const countries = [
  'United Kingdom',
  'United States',
  'Austria',
  'Ireland',
  'Spain',
  'Italy',
];

const categories = {
  'Top categories': [
    { label: 'People and blogs', value: 'people & blogs' },
    { label: 'Travel and events', value: 'travel & events' },
    { label: 'Gaming', value: 'gaming' },
    { label: 'Comedy', value: 'comedy' },
    { label: 'Howto and style', value: 'howto & style' },
  ],
  'All other categories': [
    { label: 'Sports', value: 'sports' },
    { label: 'Film and animation', value: 'film & animation' },
    { label: 'Auto and vehicles', value: 'autos & vehicles' },
    { label: 'Music', value: 'music' },
    { label: 'Pets and animals', value: 'pets & animals' },
  ],
  '': [
    { label: 'Entertainment', value: 'entertainment' },
    { label: 'News and Politics', value: 'news & politics' },
    { label: 'Science and Technology', value: 'science & technology' },
  ],
};

export default { countries, categories };



// WEBPACK FOOTER //
// ./src/utils/data.js